import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { FEATURE_LINKS } from "@/components/MarketingNav";

// Crawlable footer for the marketing pages — plain <Link> anchors so the three
// feature pages are always reachable for users and search engines.
export function MarketingFooter() {
  return (
    <footer className="border-t border-line bg-white">
      <div className="max-w-5xl mx-auto px-6 py-12 grid gap-8 sm:grid-cols-3">
        <div>
          <Logo className="h-8" />
          <p className="text-sm text-subtle mt-3 max-w-xs leading-relaxed">
            The operating system for family care &amp; medical advocacy.
          </p>
        </div>
        <nav aria-label="Features">
          <h4 className="text-xs font-bold uppercase tracking-widest text-subtle">Features</h4>
          <ul className="mt-3 space-y-2">
            {FEATURE_LINKS.map((f) => (
              <li key={f.slug}>
                <Link
                  to={`/features/${f.slug}`}
                  data-testid={`footer-feature-${f.slug}`}
                  className="text-sm text-ink hover:text-brand hover:underline"
                >
                  {f.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Company">
          <h4 className="text-xs font-bold uppercase tracking-widest text-subtle">Company</h4>
          <ul className="mt-3 space-y-2">
            <li><Link to="/legal" data-testid="footer-legal" className="text-sm text-ink hover:text-brand hover:underline">Legal &amp; privacy</Link></li>
            <li><a href="https://trust.kinbridgehealth.com/" target="_blank" rel="noopener noreferrer" data-testid="footer-trust-center" className="text-sm text-ink hover:text-brand hover:underline">Trust Center</a></li>
            <li><Link to="/login" data-testid="footer-signin" className="text-sm text-ink hover:text-brand hover:underline">Sign in</Link></li>
            <li><Link to="/signup" data-testid="footer-signup" className="text-sm text-ink hover:text-brand hover:underline">Create a caregiver account</Link></li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-line">
        <p className="max-w-5xl mx-auto px-6 py-5 text-xs text-subtle">
          © {new Date().getFullYear()} KinBridge Health · HIPAA-conscious · Cancel anytime
        </p>
      </div>
    </footer>
  );
}
